<template>
  <div>
    <CCard>
      <CCardHeader>
        <CCardTitle
          style="display: inline-block; margin-top: 8px; margin-bottom: 0px"
          ><h3>
            {{ lote.nombreConcurso }} - {{ lote.nombreExpediente }}: Lote
            {{ lote.numero }}
          </h3></CCardTitle
        >
        <b></b>
        <CButton
          style="
            display: inline-block;
            float: right;
            margin-top: 8px;
            margin-bottom: 8px;
          "
          color="secondary"
          @click="returnPage"
          >Volver</CButton
        >
        <CDropdown
          toggler-text="Modificar estado del lote"
          style="display: inline-block; float: right"
          class="m-2"
          color="info"
        >
          <CDropdownItem
            v-for="estado in estadosDeLoteSeleccionables"
            :key="estado.id"
            @click="seleccionarEstadoLote(estado)"
            ><b>{{ estado.descripcion }}</b></CDropdownItem
          >
        </CDropdown>
      </CCardHeader>
      <CCardBody>
        <CRow form class="form-group">
          <CCol sm="3">
            <b>Concurso</b>
          </CCol>
          <CCol sm="9">
            {{ lote.nombreConcurso }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Expediente</b>
          </CCol>
          <CCol sm="9">
            {{ lote.nombreExpediente }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Estado</b>
          </CCol>
          <CCol sm="9">
            <CBadge :color="getBadgeEstado(lote.descripcionEstadoLote)">{{
              lote.descripcionEstadoLote
            }}</CBadge>
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Fecha de adjudicación</b>
          </CCol>
          <CCol sm="9">
            {{ formatDate(lote.fechaAdjudicacion) }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Tipo de lote</b>
          </CCol>
          <CCol sm="9">
            {{ lote.descripcionTipoLote }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Provincia</b>
          </CCol>
          <CCol sm="9">
            {{ lote.nombreProvincias }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Código de ruta</b>
          </CCol>
          <CCol sm="9">
            {{ lote.codigoRuta }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Número de ruta</b>
          </CCol>
          <CCol sm="9">
            {{ lote.numeroRuta }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Tramo tarifario</b>
          </CCol>
          <CCol sm="9">
            {{ lote.descripcionTramoTarifario }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Nivel</b>
          </CCol>
          <CCol sm="9">
            {{ lote.descripcionNivel }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Plazas previstas</b>
          </CCol>
          <CCol sm="9">
            {{ lote.numPlazasPrevistas }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Requiere Vehículo Adaptado</b>
          </CCol>
          <CCol sm="9">
            {{ lote.vehiculoAdaptado == null ? "" : (lote.vehiculoAdaptado == 1 ? "Si" : "No") }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Kilómetros</b>
          </CCol>
          <CCol sm="9">
            {{ lote.km }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Dias Sept-Nov</b>
          </CCol>
          <CCol sm="9">
            {{ lote.diasSeptNov }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Dias Dic-Jun</b>
          </CCol>
          <CCol sm="9">
            {{ lote.diasDicJun }}
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Precio dia</b>
          </CCol>
          <CCol sm="9"> {{ lote.precioDiaSinIVA }}  </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Precio licitación</b>
          </CCol>
          <CCol sm="9"> {{ lote.presupuestoLicitacionSinIVA }} </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Valor contrato</b>
          </CCol>
          <CCol sm="9"> {{ lote.valorContratoSinIVA }}  </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Límite baja</b>
          </CCol>
          <CCol sm="9"> {{ lote.limiteBaja }}  </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol sm="3">
            <b>Periodos</b>
          </CCol>
          <CCol sm="9" v-if="lote.periodos && lote.periodos.length > 0">
            <CDataTable
              hover
              striped
              :items-per-page="5"
              :items="lote.periodos"
              :fields="camposPeriodos"
              sorter
              pagination
            >
            </CDataTable>
          </CCol>
          <CCol sm="9" v-if="lote.periodos && lote.periodos.length == 0">
            Sin registros
          </CCol>
        </CRow>

        <CCard form class="form-group">
          <CCardHeader
            sm="12"
            class="d-flex justify-content-between align-items-center"
          >
            <b>Lotes ofertados</b>
            <div>
              <CButton
                color="danger"
                v-if="resolviendoEmpates"
                style="display: inline-block; margin-right: 7.5px"
                @click="cancelarCambiosEmpate"
                >Cancelar</CButton
              >
              <CButton
                color="info"
                v-if="lote.empates"
                style="display: inline-block; margin-right: 7.5px"
                @click="modificarEmpates"
                >{{
                  resolviendoEmpates ? "Guardar cambios" : "Resolver empates"
                }}</CButton
              >       
              <CButton
                color="info"
                style="display: inline-block"
                @click="showFiltrosCampo = true"
                >Filtrar columnas</CButton
              >
              <CustomExport
                style="display: inline-block"
                :lista="lote.listaLotesFiltrados"
                :fields="camposOferta"
                :name="lote.nombreExpediente + ' - Lote 1 - Ofertas'"
              ></CustomExport>
            </div>
          </CCardHeader>
          <CDataTable
            v-if="lote.lotesOfertados && lote.lotesOfertados.length > 0"
            hover
            :tableFilter="{ placeholder: 'Introducir valor', label: 'Buscar', external: true, lazy: true }"
            :table-filter-value.sync="tableFilterVal"
            :itemsPerPageSelect="{
              label: 'Elementos por página',
              values: [5, 10, 15, 20, 25],
            }"
            striped
            :items-per-page="5"
            :items="lote.listaLotesFiltrados"
            :fields="camposOfertaFiltrados"
            sorter
            :pagination-change="setColorPrimerPuesto"
            :page-change="setColorPrimerPuesto"
            :columnFilter='{ external: true, lazy: true }'
            :column-filter-value.sync="columnFilterVal"
            pagination
          >
            <template #puestoConcurso="{ item, index }">
              <td>
                <CBadge
                  style="font-size: 17px; margin-top: 10px"
                  v-if="!resolviendoEmpates"
                  :color="getBadgePosicion(item.puestoConcurso)"
                  >{{ item.puestoConcurso }}</CBadge
                >
                <CInput
                  v-if="listaDesempate[index] && resolviendoEmpates && parseFloat(item.puntos) >= 0"
                  @focus="selectOfertaAModificar(item)"
                  @input="handlePuesto"
                  type="number"
                  v-model="listaDesempate[index].puestoConcurso"
                />
              </td>
            </template>
            <template #acciones="{ item }">
              <td>
                <CDropdown
                  v-if="ofertaOptaALote(item)"
                  toggler-text="Asignación del lote"
                  style="display: inline-block"
                  class="m-2"
                  color="info"
                >
                  <div
                    v-for="estado in estadosOfertamModificables(item)"
                    :key="estado.descripcion"
                  >
                    <CDropdownItem
                      @click="seleccionarEstadoOferta(estado, item)"
                      ><b>{{ estado.descripcion }}</b></CDropdownItem
                    >
                  </div>
                  <CDropdownDivider />
                  <CDropdownItem @click="excluirOferta(item)"
                    ><b>Excluir oferta</b></CDropdownItem
                  >
                </CDropdown>
                <CDropdown
                  v-if="item.baja == 'Si'"
                  toggler-text="Modificar baja"
                  style="display: inline-block"
                  class="m-2"
                  color="info"
                >
                  <CDropdownItem @click="siJustificarBaja(item)"
                    >Marcar como justificada</CDropdownItem
                  >
                  <CDropdownDivider />
                  <CDropdownItem @click="noJustificarBaja(item)"
                    >Marcar como no justificada</CDropdownItem
                  >
                </CDropdown>
              </td>
            </template>
            <template #descripcionEstado="{ item }">
              <td>
                <CBadge :color="getBadgeEstado(item.descripcionEstado)">{{
                  item.descripcionEstado
                }}</CBadge>
              </td>
            </template>
            <template #precioDiaSinIVA="{ item }">
              <td>
                {{ item.precioDiaSinIVA ? item.precioDiaSinIVA : 0 }}                
              </td>
            </template>
            <template #descripcionEmision="{ item }">
              <td>
                {{ item.descripcionEmision ? item.descripcionEmision : "-" }}
              </td>
            </template>
            <template #distanciaCentroTrabajo="{ item }">
              <td>
                {{
                  item.distanciaCentroTrabajo
                    ? item.distanciaCentroTrabajo
                    : "-"
                }}
              </td>
            </template>
            <template #distanciaTallerCochera="{ item }">
              <td>
                {{
                  item.distanciaTallerCochera
                    ? item.distanciaTallerCochera
                    : "-"
                }}
              </td>
            </template>
            <template #accesibilidad="{ item }">
              <td>
                <CBadge :color="getBadgeValores(item.accesibilidad)">
                  {{ item.accesibilidad ? item.accesibilidad : "-" }}
                </CBadge>
              </td>
            </template>
            <template #cumpleUNE26494="{ item }">
            <td>
              <CBadge :color="getBadgeValores(item.cumpleUNE26494)">
                {{ item.cumpleUNE26494 ? item.cumpleUNE26494 : "-" }}
              </CBadge>
            </td>
          </template>
            <template #estabilidadLaboral="{ item }">
              <td>
                <CBadge :color="getBadgeValores(item.estabilidadLaboral)">
                  {{ item.estabilidadLaboral ? item.estabilidadLaboral : "-" }}
                </CBadge>
              </td>
            </template>
            <template #vehiculoDisponible="{ item }">
              <td>
                <CBadge :color="getBadgeValores(item.vehiculoDisponible)">
                  {{ item.vehiculoDisponible ? item.vehiculoDisponible : "-" }}
                </CBadge>
              </td>
            </template>
            <template #baja="{ item }">
              <td>
                <CBadge :color="getBadgeBajaExcluido(item.baja)">
                  {{ item.baja ? item.baja : "-" }}
                </CBadge>
              </td>
            </template>
            <template #excluido="{ item }">
              <td>
                <CBadge :color="getBadgeBajaExcluido(item.excluido)">
                  {{ item.excluido ? item.excluido : "-" }}
                </CBadge>
              </td>
            </template>
            
          </CDataTable>
          <CCardBody
            v-if="lote.lotesOfertados && lote.lotesOfertados.length == 0"
          >
            Sin ofertas
          </CCardBody>
        </CCard>
      </CCardBody>
    </CCard>

    <CModal
      title="Filtrar columnas de la tabla"
      :show.sync="showFiltrosCampo"
      size="lg"
      centered
    >
      <CRow>
        <CCol
          v-for="(campo, index) in camposOferta"
          :key="index"
          sm="6"
          v-if="campo.label != 'Seleccionar'"
          ><CInputCheckbox
            :label="campo.label"
            :checked="camposOfertaFiltrados.indexOf(campo) > -1"
            @change="setFiltroCampoValue(campo)"
        /></CCol>
      </CRow>

      <template #footer>
        <CButton @click="showFiltrosCampo = false" color="info"
          >Aceptar</CButton
        >
      </template>
    </CModal>

    <CModal
      title="Modificar estado"
      :show.sync="showModificarEstado"
      size="lg"
      centered
    >
      <div v-html="modificarMensaje">{{ modificarMensaje }}</div>

      <template #footer>
        <CButton
          v-if="ofertaOLote > -1"
          @click="showModificarEstado = false"
          color="danger"
          >Cancelar</CButton
        >
        <CButton
          v-if="ofertaOLote > -1"
          @click="modificarEstado"
          color="success"
          >Aceptar</CButton
        >
        <CButton
          v-if="ofertaOLote == -1"
          @click="showModificarEstado = false"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>

    <CModal
      title="Modificar baja"
      :show.sync="showBajaOferta"
      size="lg"
      centered
    >
      <div v-html="modificarMensaje">{{ modificarMensaje }}</div>

      <template #footer>
        <CButton @click="showBajaOferta = false" color="info">Cancelar</CButton>
        <CButton @click="modificarBaja" color="danger">Modificar</CButton>
      </template>
    </CModal>

    <CModal
      title="Excluir oferta"
      :show.sync="showExcluirOferta"
      size="lg"
      centered
    >
      <div v-html="modificarMensaje">{{ modificarMensaje }}</div>

      <CRow style="margin-top: 15px">
        <CCol sm="12">
          <b>Motivo de la exclusión:</b>
        </CCol>
        <CCol style="margin-top: 10px" sm="12">
          <CTextarea @input="handleMotivo" />
        </CCol>
      </CRow>

      <CRow v-if="errorExclusion">
        <CCol sm="12" style="color:red">
          El motivo de exclusión es un campo obligatorio y no puede quedar vacío.
        </CCol>
      </CRow>

      <template #footer>
        <CButton @click="showExcluirOferta = false" color="info"
          >Cancelar</CButton
        >
        <CButton @click="aceptarExcluirOferta" color="danger">Excluir</CButton>
      </template>
    </CModal>
  </div>
</template>

<style>
.my-2 {
  margin-left: 15px !important;
  padding-right: 15px !important;
}

.primera {
  color: rgb(216, 200, 108);
  font-size: 25px;
}

.primer-puesto {
}

.primer-puesto:hover {
}
</style>

<script>
import Cookies from "js-cookie";
import CustomExport from "../../utils/CustomExport";
import { logOut } from "../../utils/authUtils";
import { setTableFilterValue, setColumnFilterValue } from '../../utils/filterUtils'
import {
  modificarLoteOfertado,
  excluirOferta,
  marcarNoJustificada,
  marcarSiJustificada,
  adjudicarLote,
  quitarLote,
  asignadoValidadoLoteOfertado,
  asignadoPdteValidarLoteOfertado,
  asignadoPdteSubsanacionLoteOfertado,
} from "../../requests/ofertas";
import {
  getDetallesLote,
  modificarDesierto,
  modificarDesistido,
  reordenarOfertas,
} from "../../requests/lotes";
import {
  getEstadoLotes,
  getEstadoLotesOfertados,
} from "../../requests/utilities";
import {
  getDetallesConcurso
} from "../../requests/concursos";

export default {
  name: "DetallesLote",
  components: {
    CustomExport,
  },
  created() {},
  mounted() {
    this.cargarDatosLote();
  },
  data() {
    return {
      idLote: 0,
      lote: {}, //objecto con la info del lote
      concurso: {}, //info del concurso al que pertenece el lote
      camposPeriodos: [
        //campos de la tabla de periodos
        { key: "nombre", field: "Nombre", label: "Nombre" },
        {
          key: "valorSeptNov",
          field: "Septiembre - Noviembre",
          label: "Septiembre - Noviembre",
        },
        {
          key: "valorDicJun",
          field: "Diciembre - Junio",
          label: "Diciembre - Junio",
        },
      ],
      estadosDeLote: [], //lista con los posibles estados de un lote
      estadosDeLoteSeleccionables: [], //lista con los estados a los que se puede modificar un lote
      estadosDeOferta: [], //lista con los posibles estados de una oferta,
      showExcluirOferta: false, //muestra el modal para excluir una oferta
      showModificarEstado: false, //muestra el modal de confirmacion para modificar un lote o oferta
      showBajaOferta: false, //muestra el modal para justificar o no una baja
      tipoJustificacion: false, //true = justificar baja, false = no justificar
      motivoExclusion: "", //motivo de exclusion si se excluye una oferta
      resolviendoEmpates: false, //permite modificar los puestos de las ofertas si hay empates
      listaDesempate: [], //lista con las ofertas para desempatar
      modificarMensaje: "", //mensaje a mostrar en el modal de confirmacion de modificacion
      estadoLoteSeleccionado: 0, //estado del lote seleccionado en el desplegable cuando se va a modificar el estado
      estadoOfertaSeleccionada: 0, //estado de la oferta seleccionada en el desplegable cuando se va a modificar el estado de una oferta
      ofertaSeleccionada: {}, //oferta seleccionada a modificar algun estado
      ofertaOLote: 0, // 0 si se va a modificar el estado del lote, 1 si se va a modificar un lote ofertado, -1 para mostrar informacion, para el boton que haga la request
      showFiltrosCampo: false, //muestra el modal para filtrar la tabla
      errorExclusion: false, //muestra el mensaje de error en la ventanita para excluir
      camposOfertaFiltrados: [], //campos seleccionados para la tabla de ofertas
      tableFilterVal: "",
      columnFilterVal: {},
      camposOferta: [
        { key: "acciones", field: "Seleccionar", label: "Seleccionar" },
        { key: "puestoConcurso", field: "Puesto", label: "Puesto" },
        { key: "puntos", field: "Puntos", label: "Puntos" },
        { key: "baja", field: "Baja", label: "Baja" },
        { key: "excluido", field: "Excluido", label: "Excluido" },
        { key: "motivoExlusion", field: "Motivo Exclusion", label: "Motivo Exclusion" },        
        {
          key: "ordenPreferencia",
          field: "Orden Preferencia",
          label: "Orden Preferencia",
        },
        { key: "nombreLicitador", field: "Nombre", label: "Nombre" },
        { key: "dninifLicitador", field: "DNI / CIF", label: "DNI / CIF" },
        { key: "descripcionEstado", field: "Estado", label: "Estado" },
        {
          key: "precioDiaSinIVA",
          field: "Precio dia",
          label: "Precio dia",
        },
        {
          key: "plazasTotales",
          field: "Plazas totales",
          label: "Plazas totales",
        },
        {
          key: "descripcionAntiguedad",
          field: "Antiguedad",
          label: "Antiguedad",
        },
        {
          key: "descripcionEmision",
          field: "Emisiones",
          label: "Emisiones",
        },
        {
          key: "estabilidadLaboral",
          field: "Estabilidad laboral",
          label: "Estabilidad laboral",
        },
        {
          key: "accesibilidad",
          field: "Accesibilidad",
          label: "Accesibilidad",
        },
        {
          key: "cumpleUNE26494",
          field: "Acredita oficialmente adaptación",
          label: "Acredita oficialmente adaptación",
        },
        {
          key: "descripcionContinuidad",
          field: "Compromiso Continuidad",
          label: "Compromiso Continuidad",
        },
        /*{
          key: "distanciaCentroTrabajo",
          field: "Distancia al centro de trabajo",
          label: "Distancia al centro de trabajo",
        },
        {
          key: "distanciaTallerCochera",
          field: "Distancia del taller a la cochera",
          label: "Distancia del taller a la cochera",
        },*/
      ],
    };
  },
  computed: {
    tableState() {
      return [
        this.columnFilterVal,
        this.tableFilterVal,
      ];
    }
  },
  watch: {
    tableState() {
      this.lote.listaLotesFiltrados = this.lote.lotesOfertados
      this.setColumnFilter();
      this.setTableFilter();
    }
  },  
  methods: {
    setColumnFilter() {
      this.lote.listaLotesFiltrados = setColumnFilterValue(this.columnFilterVal, this.lote.listaLotesFiltrados)
      // console.log(this.lotesOfertadosFiltrados);
      // console.log("this.lotesOfertadosFiltrados columna");
    },
    setTableFilter() {
      this.lote.listaLotesFiltrados = setTableFilterValue(this.tableFilterVal, this.lote.listaLotesFiltrados)
      // console.log(this.lotesOfertadosFiltrados);
      // console.log("this.lotesOfertadosFiltrados tabla");
    },
    cargarDatosLote() {
      this.camposOfertaFiltrados = Array.from(this.camposOferta);

      getEstadoLotes().then((res) => {
        //recoge los estados de un lote y una oferta
        this.estadosDeLote = res.data;
        this.estadosDeLoteSeleccionables = [];
        this.estadosDeLote.forEach((estado) => {
          if (
            estado.descripcion == "Desistido o renunciado" ||
            estado.descripcion == "Desierto"
          ) {
            this.estadosDeLoteSeleccionables.push(estado);
          }
        });
      });

      getEstadoLotesOfertados().then((res) => {
        this.estadosDeOferta = res.data;
      });

      this.idLote = this.$route.query.id;

      getDetallesLote(this.idLote)
        .then((res) => {
          this.lote = res.data;
          //modeficamos los valores del lote para mostrar bien la info
          this.lote.precioDiaSinIVA=Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(this.lote.precioDiaSinIVA);
          this.lote.presupuestoLicitacionSinIVA=Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(this.lote.presupuestoLicitacionSinIVA);
          this.lote.valorContratoSinIVA=Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(this.lote.valorContratoSinIVA);
          this.lote.limiteBaja=Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(this.lote.limiteBaja);

          //modificamos los valores de lotesOfertados para que tengan formato moneda
          this.lote.lotesOfertados.forEach(milote =>
          {
            milote.puntos=Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(milote.puntos);
            milote.precioDiaSinIVA=Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(milote.precioDiaSinIVA)+" €";
          });

            //modificamos los valores de periodos para que tengan formato moneda
          this.lote.periodos.forEach(miperiodo =>
          {
            miperiodo.valorSeptNov=Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(miperiodo.valorSeptNov);
            miperiodo.valorDicJun=Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(miperiodo.valorDicJun);
           
          });

          this.lote.listaLotesFiltrados = this.lote.lotesOfertados;
          

          getDetallesConcurso(this.lote.idConcurso).then(resConcurso => {
            this.concurso = resConcurso.data;
          })

          this.lote.lotesOfertados.sort(function (a, b) {
            //ordena la lista de ofertas de mas a menos puntlos
            if (a.puestoConcurso && b.puestoConcurso)
              return a.puestoConcurso - b.puestoConcurso;

            if (a.puestoConcurso) return b.puestoConcurso - a.puestoConcurso;

            if (b.puestoConcurso) return b.puestoConcurso - a.puestoConcurso;

            return a.puestoConcurso - b.puestoConcurso;
          });
          //console.log(this.lote.lotesOfertados)
          setTimeout(this.handleLotesOfertados, 100); //se modifica algun campo de cada oferta
        })
        .catch((error) => {
          if (error.response.status == 403 || error.response.status == 401)
            logOut(this.$router);
        });
    },
    setColorPrimerPuesto() {
      //colorea las filas de los primeros puestos
      let rows = document.getElementsByClassName("primera");
      rows.forEach((row) => {
        //console.log(row.parentElement.parentElement);
        row.parentElement.parentElement.classList.add("primer-puesto");
      });
    },
    //pendientes de ser modificados para ver que colores se eligen, son el color de los cartelitos de estado
    getBadgeEstado(situacion) {
      switch (situacion) {
        case "Sin Asignar":
          return "danger";
        case "Asignado Pendiente Validar":
          return "info";
        case "Asignado Pendiente Desempate":
          return "warning";
        case "Asignado Validado":
          return "success";
        case "Adjudicado":
          return "success";
        case "Asignado Pendiente Subsanación":
          return "warning";
        case "Desistido o renunciado":
          return "danger";
        case "Desierto":
          return "danger";
        default:
          return "warning";
      }
    },
    getBadgePosicion(idEstado) {
      switch (idEstado) {
        case 1:
          return "success";
        case 2:
          return "info";
        case 3:
          return "info";
        default:
          return "secondary";
      }
    },
    getBadgeValores(valor) {
      switch (valor) {
        case "Si":
          return "success";
        case "No":
          return "danger";
        default:
          return "";
      }
    },
    getBadgeBajaExcluido(valor) {
      switch (valor) {
        case "Si":
          return "danger";
        case "No":
          return "success";
        case "Justificada":
          return "success";
        case "No Justificada":
          return "danger";
        default:
          return "secondary";
      }
    },
    returnPage() {
      //para volver a la pagina anterior
      this.$router.back();
    },
    handleLotesOfertados() {
      //modifica algunos campos de las ofertas
      this.lote.lotesOfertados.forEach((lote) => {
        let objetoOferta = Object.create(lote);
        if(lote.puestoConcurso)
          this.listaDesempate.push({
            idLoteOfertado: lote.id,
            puestoConcurso: lote.puestoConcurso,
          });
        lote.puestoConcurso = lote.puestoConcurso
          ? lote.puestoConcurso
          : "Sin calcular";
        lote.excluido = lote.excluido == 0 ? "No" : "Si";
        lote.motivoExlusion = lote.motivoExlusion ? lote.motivoExlusion : "-";
        lote.accesibilidad = lote.accesibilidad == 0 ? "No" : "Si";
        lote.cumpleUNE26494 = lote.cumpleUNE26494 == null ? "" : (lote.cumpleUNE26494 == 0 ? "No" : "Si");       
        lote.plazasTotales = lote.plazasTotales ? lote.plazasTotales : "-";
        lote.descripcionContinuidad = lote.descripcionContinuidad ? lote.descripcionContinuidad : "-";
        if(lote.estabilidadLaboral==null)
        {lote.estabilidadLaboral="-";}else{lote.estabilidadLaboral = lote.estabilidadLaboral == 0 ? "No" : "Si";}
      });
    },
    setFiltroCampoValue(campo) {
      //añade o elimina campos de la tabla de las ofertas
      if (this.camposOfertaFiltrados.indexOf(campo) > -1) {
        this.camposOfertaFiltrados.splice(
          this.camposOfertaFiltrados.indexOf(campo),
          1
        );
      } else this.camposOfertaFiltrados.push(campo);
    },
    ofertaOptaALote(oferta) {
      //si una oferta opta a ser adjudicada manualmente a un lote o no
      return oferta.baja != "Si" && oferta.excluido == "No";
    },
    seleccionarEstadoLote(estado) {
      this.estadoLoteSeleccionado = estado.id;
      this.ofertaOLote = 0;
      this.modificarMensaje =
        "Se va a modificar el estado del lote a <b>" + estado.descripcion;
      ("</b>");
      this.showModificarEstado = true;
    },
    seleccionarEstadoOferta(estado, oferta) {
      this.estadoOfertaSeleccionada = estado.id;
      this.ofertaSeleccionada = oferta;
      this.ofertaOLote = 1;
      this.modificarMensaje =
        "Se va a modificar el estado de la oferta del licitador <b>" +
        oferta.nombreLicitador +
        "</b> con <b>" +
        oferta.puntos +
        " puntos</b> a <b>" +
        estado.descripcion +
        "</b>";
      this.showModificarEstado = true;
    },
    excluirOferta(oferta) {
      this.ofertaSeleccionada = oferta;
      this.modificarMensaje =
        "Se va a excluir la oferta del licitador <b>" +
        oferta.nombreLicitador +
        "</b> con <b>" +
        oferta.puntos +
        " puntos</b>";

      this.showExcluirOferta = true;
    },
    handleMotivo(value) {
      this.motivoExclusion = value;
    },
    aceptarExcluirOferta() {
      if(this.motivoExclusion == ""){
        this.errorExclusion = true;
        return;
      }
      excluirOferta(this.motivoExclusion, this.ofertaSeleccionada.id)
        .then((res) => {
          this.showExcluirOferta = false;
          let mensaje = "Se ha excluido la oferta correctamente.";
          this.mostrarInformacion(mensaje);
          this.cargarDatosLote();
        })
        .catch((error) => {
          this.showExcluirOferta = false;
          this.mostrarInformacion("No se ha podido excluir el lote ofertado.");
        });
    },
    mostrarInformacion(mensaje) {
      //muestra informacion usando el modal de modificar
      this.modificarMensaje = mensaje;
      this.ofertaOLote = -1;
      this.showModificarEstado = true;
    },
    siJustificarBaja(oferta) {
      //muestra los modales para aceptar
      this.ofertaSeleccionada = oferta;
      this.justificarBaja = true;
      this.modificarMensaje =
        "Se va a marcar la oferta del licitador <b>" +
        oferta.nombreLicitador +
        "</b> como <b>JUSTIFICADA</b>.";
      this.showBajaOferta = true;
      //console.log(this.showBajaOferta);
    },
    noJustificarBaja(oferta) {
      this.ofertaSeleccionada = oferta;
      this.justificarBaja = false;
      this.modificarMensaje =
        "Se va a marcar la oferta del licitador <b>" +
        oferta.nombreLicitador +
        "</b> como <b>NO JUSTIFICADA</b>.";
      this.showBajaOferta = true;
    },
    modificarBaja() {
      if (this.justificarBaja) {
        this.marcarBajaJustificada();
      } else {
        this.marcarBajaNoJustificada();
      }
    },
    marcarBajaJustificada() {
      marcarSiJustificada(this.ofertaSeleccionada.id)
        .then((res) => {
          this.showBajaOferta = false;
          this.mostrarInformacion("Baja justificada correctamente.");
          this.cargarDatosLote();
        })
        .catch((error) => {
          this.showBajaOferta = false;
          this.mostrarInformacion(
            "No se ha podido justificar la baja del lote ofertado. Causa: " +
              error.response.data.error
          );
        });
    },
    marcarBajaNoJustificada() {
      marcarNoJustificada(this.ofertaSeleccionada.id)
        .then((res) => {
          this.showBajaOferta = false;
          this.mostrarInformacion("Baja no justificada correctamente.");
          this.cargarDatosLote();
        })
        .catch((error) => {
          this.showBajaOferta = false;
          this.mostrarInformacion(
            "No se ha podido no justificar la baja del lote ofertado. Causa: " +
              error.response.data.error
          );
        });
    },
    formatDate(date) {
      if(date == null)
        return "Pendiente"
      date = new Date(date);
      let hora = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
      let minutos =
        date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();

      let dia = date.getDate();
      let mes = date.getMonth() + 1;
      let ano = date.getFullYear();

      return dia + "/" + mes + "/" + ano + " " + hora + ":" + minutos;
    },
    formatNumberMoneda(number)
    {
      return Intl.NumberFormat("es-ES").format(number);
    },
    estadosOfertamModificables(oferta) {
      //devuelve la lista de estados a los que se puede modificar una oferta

      if(this.concurso.idEstadoConcurso != 2)
        return [];

      /* AÑADIR EXCLUIR LOTE */
      switch (oferta.descripcionEstado) {
        case this.estadosDeOferta[0].descripcion: //sin asignar
          return [
            this.estadosDeOferta[1], //solo puede pasar a asignado pendiente de validar
          ];

        case this.estadosDeOferta[1].descripcion: //asignado pendiente de validar
          return [
            this.estadosDeOferta[0], //sin asignar
            this.estadosDeOferta[3], //asignado validado
            this.estadosDeOferta[5], //asignado pendiente de subsanacion
          ];

        case this.estadosDeOferta[2].descripcion: //asignado pendiente de desempate
          return [
            this.estadosDeOferta[0], //sin asignar
            this.estadosDeOferta[1], //asignado pendiente de validar
          ];

        case this.estadosDeOferta[3].descripcion: //asignado validado
          return [
            this.estadosDeOferta[0], //sin asignar
            this.estadosDeOferta[4], //adjudicado
          ];

        case this.estadosDeOferta[4].descripcion: //adjudicado
          return [
            this.estadosDeOferta[0], //sin asignar
          ];

        case this.estadosDeOferta[5].descripcion: //asignado pendiente de subsanacion
          return [
            this.estadosDeOferta[0], //sin asignar
            this.estadosDeOferta[3], //asignado validado
          ];
      }
    },
    modificarEstado() {
      this.showModificarEstado = false;
      if (this.ofertaOLote == 0) {
        //si lo que se modifica es el lote
        if (this.estadoLoteSeleccionado == 4) {
          modificarDesistido(this.lote)
            .then((res) => {
              this.mostrarInformacion(
                "Estado del lote modificado correctamente."
              );
              this.cargarDatosLote();
            })
            .catch((error) => {
              this.mostrarInformacion(
                "No se ha podido modificar el estado del lote."
              );
            });
        } else if (this.estadoLoteSeleccionado == 5) {
          modificarDesierto(this.lote)
            .then((res) => {
              this.mostrarInformacion(
                "Estado del lote modificado correctamente."
              );
              this.cargarDatosLote();
            })
            .catch((error) => {
              this.mostrarInformacion(
                "No se ha podido modificar el estado del lote."
              );
            });
        }
      } else {
        //si lo que se modifica es una oferta
        switch (this.estadoOfertaSeleccionada) {
          case this.estadosDeOferta[0].id: //sin asignar
            quitarLote(this.ofertaSeleccionada.id, this.idLote)
              .then((res) => {
                this.mostrarInformacion("Lote ofertado desasignado.");
                this.cargarDatosLote();
              })
              .catch((error) => {
                this.mostrarInformacion(
                  "No se ha podido modificar el lote ofertado.<br> Causa: <b>" +
                    error.response.data.error +
                    "</b>"
                );
              });
            break;
          case this.estadosDeOferta[1].id: //asignado pendiente de validar
            asignadoPdteValidarLoteOfertado(
              this.ofertaSeleccionada.id,
              this.idLote
            )
              .then((res) => {
                this.mostrarInformacion(
                  "Lote ofertado marcado como Asignado Pendiente de validar."
                );
                this.cargarDatosLote();
              })
              .catch((error) => {
                this.mostrarInformacion(
                  "No se ha podido modificar el lote ofertado.<br> Causa: <b>" +
                    error.response.data.error +
                    "</b>"
                );
              });
            break;
          case this.estadosDeOferta[2].id: //asignado pendiente de desempate
            break;
          case this.estadosDeOferta[3].id: //asignado validado
            asignadoValidadoLoteOfertado(
              this.ofertaSeleccionada.id,
              this.idLote
            )
              .then((res) => {
                this.mostrarInformacion(
                  "Lote ofertado marcado como asignado validado."
                );
                this.cargarDatosLote();
              })
              .catch((error) => {
                this.mostrarInformacion(
                  "No se ha podido modificar el lote ofertado.<br> Causa: <b>" +
                    error.response.data.error +
                    "</b>"
                );
              });
            break;
          case this.estadosDeOferta[4].id: //adjudicado
            adjudicarLote(this.ofertaSeleccionada.id, this.idLote)
              .then((res) => {
                this.mostrarInformacion("Lote ofertado adjudicado.");
                this.cargarDatosLote();
              })
              .catch((error) => {
                this.mostrarInformacion(
                  "No se ha podido modificar el lote ofertado.<br> Causa: <b>" +
                    error.response.data.error +
                    "</b>"
                );
              });
            break;
          case this.estadosDeOferta[5].id: //asignado pendiente de subsanacion
            asignadoPdteSubsanacionLoteOfertado(
              this.ofertaSeleccionada.id,
              this.idLote
            )
              .then((res) => {
                this.mostrarInformacion(
                  "Lote ofertado modificado a Asignado Pendiente de subsanación."
                );
                this.cargarDatosLote();
              })
              .catch((error) => {
                this.mostrarInformacion(
                  "No se ha podido modificar el lote ofertado.<br> Causa: <b>" +
                    error.response.data.error +
                    "</b>"
                );
              });
            break;
        }
      }
    },
    modificarEmpates() {
      if (this.resolviendoEmpates) {
        this.resolviendoEmpates = false;
        reordenarOfertas(this.lote, this.listaDesempate)
          .then((res) => {
            this.mostrarInformacion(
              "Lista de ofertas reordenada correctamente. "
            );
            this.cargarDatosLote();
          })
          .catch((error) => {
            this.mostrarInformacion(
              "No se han podido modificar los puestos de los lotes.<br> Causa: <b>" +
                error.response.data.error +
                "</b>"
            );
          });
      } else {
        this.resolviendoEmpates = true;
      }
    },
    selectOfertaAModificar(oferta) {
      this.ofertaSeleccionada = oferta;
    },
    handlePuesto(value) {
      this.listaDesempate.forEach((oferta) => {
        if (oferta.idLoteOfertado == this.ofertaSeleccionada.id) {
          oferta.puestoConcurso = parseInt(value);
        }
      });
    },
    cancelarCambiosEmpate(){
      this.listaDesempate = [];
      this.lote.lotesOfertados.forEach((lote) => {  
        if(lote.puestoConcurso)
          this.listaDesempate.push({
            idLoteOfertado: lote.id,
            puestoConcurso: lote.puestoConcurso,
          });
      });
      this.resolviendoEmpates = false;
      //console.log(this.listaDesempate)
    }
  },
  beforeDestroy() {},
};
</script>
